import React, { useEffect, useRef } from "react";
import "../css/normalize.css";
import "../css/style.css";
import "../css/all.min.css";
import { images } from "./importingScript";
import "./home.css";

export default function Home() {
  const carouselRef = useRef(null);

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    const interval = setInterval(() => {
      const nextButton = carousel.querySelector(".carousel-control-next");
      if (nextButton) nextButton.click();
    }, 4000); // change slide every 4 seconds

    // pause on hover
    carousel.addEventListener("mouseenter", () => clearInterval(interval));
    carousel.addEventListener("mouseleave", () => {
      setInterval(() => {
        const nextButton = carousel.querySelector(".carousel-control-next");
        if (nextButton) nextButton.click();
      }, 4000);
    });

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero1">
      <div className="container-fluid px-0" ref={carouselRef}>
        <div
          id="header-carousel"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">

            {/* Slide 1 */}
            <div className="carousel-item active">
              <img className="w-100 carousel-img" src={images["./carousel-1.jpg"]} alt="Slide 1" />
              <div className="carousel-caption left-caption">
                <h1 className="slide-title">Unlock Your Business Growth</h1>
                <p className="slide-tagline">Empowering you with the best digital tools</p>
                <a href="#" className="btn-main">Explore More</a>
              </div>
            </div>

            {/* Slide 2 */}
            <div className="carousel-item">
              <img className="w-100 carousel-img" src={images["./carousel-2.jpg"]} alt="Slide 2" />
              <div className="carousel-caption right-caption">
                <h1 className="slide-title">Expand Your Reach Globally</h1>
                <p className="slide-tagline">Let your business go beyond borders</p>
                <a href="#" className="btn-main">Explore More</a>
              </div>
            </div>

            {/* Slide 3 */}
            <div className="carousel-item">
              <img className="w-100 carousel-img" src={images["./carousel-3.jpg"]} alt="Slide 3" />
              <div className="carousel-caption center-caption">
                <h1 className="slide-title">Dedicated Account Manager</h1>
                <p className="slide-tagline">Get personalized support for all your goals</p>
                <a href="#" className="btn-main">Explore More</a>
              </div>
            </div>

            {/* Slide 4 */}
            <div className="carousel-item">
              <img className="w-100 carousel-img" src={images["./carousel-4.jpg"]} alt="Slide 4" />
              <div className="carousel-caption left-caption">
                <h1 className="slide-title">Grow Fast, Succeed Smart</h1>
                <p className="slide-tagline">Smart solutions for modern entrepreneurs</p>
                <a href="#" className="btn-main">Explore More</a>
              </div>
            </div>
          </div>

          {/* Prev/Next buttons */}
          <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true" />
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
